"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.reopenedWorkflowActionSchema = exports.baseClosedWorkflowAction = exports.sentWorkflowActionSchema = exports.reviewResponseWorkflowActionSchema = exports.forwardedWorkflowActionSchema = exports.receivedPendingWorkflowActionSchema = exports.createdWorkflowActionSchema = exports.receivedWorkflowActionSchema = exports.workflowParticipantSchema = exports.baseWorkflowAction = void 0;
const zod_1 = require("zod");
const Purpose_1 = require("../../changeItem/types/Purpose");
const WorkflowActionType_1 = require("../project/WorkflowActionType");
const contactDetails_schema_1 = require("./contactDetails.schema");
const datetime_schema_1 = require("./datetime.schema");
const selectedItemWithName_schema_1 = require("./selectedItemWithName.schema");
const workflowActionFile_schema_1 = require("./workflowActionFile.schema");
const longField_schema_1 = require("./longField.schema");
exports.baseWorkflowAction = zod_1.z
    .object({
    id: zod_1.z.string(),
    actionType: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(WorkflowActionType_1.WorkflowActionType),
    actionDate: datetime_schema_1.datetimeSchema,
    files: workflowActionFile_schema_1.workflowActionFileSchema.array(),
    isInProgress: zod_1.z.boolean(),
})
    .strict();
exports.workflowParticipantSchema = zod_1.z.object({
    contact: contactDetails_schema_1.contactDetailsSchema,
    hasActionToPerform: zod_1.z.boolean(),
    isActionOverdue: zod_1.z.boolean(),
});
exports.receivedWorkflowActionSchema = exports.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose),
    from: exports.workflowParticipantSchema,
    to: exports.workflowParticipantSchema.array(),
})
    .strict();
exports.createdWorkflowActionSchema = exports.receivedWorkflowActionSchema;
exports.receivedPendingWorkflowActionSchema = exports.createdWorkflowActionSchema;
exports.forwardedWorkflowActionSchema = exports.baseWorkflowAction
    .extend({
    purpose: selectedItemWithName_schema_1.selectedItemWithNameSchema,
    from: exports.workflowParticipantSchema,
    to: exports.workflowParticipantSchema.array(),
    cc: exports.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    reviewDueDate: datetime_schema_1.datetimeSchema.optional(),
})
    .strict();
exports.reviewResponseWorkflowActionSchema = exports.baseWorkflowAction
    .extend({
    from: exports.workflowParticipantSchema,
    to: exports.workflowParticipantSchema.array(),
    cc: exports.workflowParticipantSchema.array(),
    response: longField_schema_1.longFieldSchema.optional(),
    action: selectedItemWithName_schema_1.selectedItemWithNameSchema,
})
    .strict();
exports.sentWorkflowActionSchema = exports.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose),
    from: exports.workflowParticipantSchema,
    to: exports.workflowParticipantSchema.array(),
    cc: exports.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
})
    .strict();
exports.baseClosedWorkflowAction = exports.baseWorkflowAction
    .extend({
    remarks: longField_schema_1.longFieldSchema.optional(),
    closedBy: exports.workflowParticipantSchema,
})
    .strict();
exports.reopenedWorkflowActionSchema = exports.baseWorkflowAction
    .extend({
    purpose: (0, selectedItemWithName_schema_1.selectedItemWithNameWithSpecificTypeSchema)(Purpose_1.Purpose, [
        Purpose_1.Purpose.ForConstruction,
        Purpose_1.Purpose.ForInformationOnly,
    ]),
    from: exports.workflowParticipantSchema,
    to: exports.workflowParticipantSchema.array(),
    remarks: longField_schema_1.longFieldSchema.optional(),
    dueDate: datetime_schema_1.datetimeSchema.optional(),
    reopenedDate: datetime_schema_1.datetimeSchema,
})
    .strict();
//# sourceMappingURL=workflowAction.schema.js.map